import React, { useEffect } from 'react'
import classes from './css/SectionThree.module.css'
import bImage from '../../assets/9.jpg'
import { Button } from '../../components/Button/Button'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Aos from 'aos'
import "aos/dist/aos.css"

interface Props {

}

export const SectionThree: React.FC<Props> = () => {
    const matches = useMediaQuery('(max-width:1094px)')
    useEffect(()=>{
        Aos.init({duration: 1300, once: false})
  
      },[])
    return (
    <section className={classes.SectionThree}>
       {matches ? null : <div className={classes.first} data-aos="fade-up">
            <img alt='Bussniess' src={bImage} className={classes.bImage}/>
        </div>}
        <div className={classes.second} data-aos="fade-up">
            <h1>عن الخدمة للشركات واصحاب الاعمال</h1>
            {matches ? 
                <img alt='Bussniess' src={bImage} className={classes.bImage}/>
             : null}
            <div dir="rtl" className={classes.employee}>
                <ul>
                    <li>لوحة تحكم كاملة لإدارة الوظائف المطلوبة</li>
                    <li>احصائيات للمشاهدات والتقديمات</li>
                    <li>تسهيل ايجاد الموظفين المطلوبين</li>
                    <li>سهولة استقبال طلبات التوظيف وتحديد موعد للمقابلة الشخصية</li>
                </ul>
            </div>
            <div className={classes.btnsDiv} data-aos="fade-up">
                <Button to='/register/employer' width={200} height={45}>التسجيل كباحث عن موظفين</Button>
            </div>
        </div>

    </section>
    )
}